import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trophy, Guitar } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import api from '@/lib/api';
import { PublicHeader, PublicFooter } from '@/components/PublicShell';

export default function RepechagePage() {
  const [entries, setEntries] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get('/public/repechage').then((r) => setEntries(r.data));
    api.get('/public/settings').then((r) => setSettings(r.data));
  }, []);

  return (
    <div>
      <PublicHeader />
      <div className="mx-auto max-w-4xl px-4 sm:px-6 py-10">
        <div className="font-display text-4xl text-white">REPESCAGEM</div>
        <p className="text-muted-foreground">Ranking dos segundos lugares por percentual de votos.</p>

        {entries.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">Nenhuma etapa finalizada ainda para gerar o ranking.</div>
        ) : (
          <Card className="mt-6 border border-border bg-card">
            <CardContent className="p-0">
              <ul className="divide-y divide-border">
                {entries.map((e, i) => (
                  <li key={`${e.stage_slug || 'stage'}-${e.band?.id || e.band?.slug || i}`} className="p-4 flex items-center gap-4" data-testid={`repechage-item-${i}`}>
                    <div className="w-10 text-center font-display text-3xl text-[var(--g66-amber)]">{i + 1}</div>
                    <div className="w-12 h-12 rounded-lg bg-[#0b0c0f] flex items-center justify-center border border-border overflow-hidden">
                      {e.band?.logo_url ? <img src={e.band.logo_url} alt={e.band.name} className="w-full h-full object-cover" /> : <Guitar className="w-5 h-5 text-muted-foreground" />}
                    </div>
                    <div className="flex-1 min-w-0">
                      <Link to={`/bandas/${e.band?.slug}`} className="font-semibold text-white hover:text-[var(--g66-amber)]">
                        {e.band?.name}
                      </Link>
                      <div className="text-xs text-muted-foreground truncate">
                        Perdeu em <Link to={`/etapas/${e.stage_slug}`} className="underline">{e.stage_title}</Link>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-display text-2xl text-white">{e.loser_percentage?.toFixed?.(1) || 0}%</div>
                      <div className="text-xs text-muted-foreground">{e.loser_votes} votos</div>
                    </div>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        )}
      </div>
      <PublicFooter settings={settings} />
    </div>
  );
}
